"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LoginConsoleProps_1 = require("./LoginConsoleProps");
var LoginConsoleState_1 = require("./LoginConsoleState");
/** Platform UI Components */
var GridContainer_1 = require("@idp/ui-components/components/containers/Grid/GridContainer");
var GridRow_1 = require("@idp/ui-components/components/containers/Grid/GridRow");
var GridColumn_1 = require("@idp/ui-components/components/containers/Grid/GridColumn");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
/** Stylesheets */
var utilityStyles = require("../../styles/utilities.scss");
var appStyles = require("../../styles/login-widget.scss");
/** LOB Components */
var CommonSpinner_1 = require("../common/CommonSpinner");
var LoginWidget_1 = require("../panels/LoginWidget/LoginWidget");
var AccountSelection_1 = require("../panels/AccountSelection/AccountSelection");
var NoWirelessAccount_1 = require("../panels/NoWirelessAccount");
var NoWirelessAccount_2 = require("../panels/NoWirelessAccount/NoWirelessAccount");
var PasscodeV2_1 = require("../panels/Passcode/PasscodeV2");
var GenericError_1 = require("../panels/GenericError/GenericError");
/** Api, Reporting, Mappers, Request, Response */
var event_bus_1 = require("@idp/event-bus");
var LoginApi_1 = require("../../api/LoginApi");
var GetUserCurrentStateResponse_1 = require("../../models/response/GetUserCurrentStateResponse");
var StateProvider_1 = require("../../api/StateProvider");
var CommonFunctions_1 = require("../common/CommonFunctions/CommonFunctions");
var DefaultsManagerService_1 = require("../../services/DefaultsManagerService");
var LoginOrchestrationService_1 = require("../../services/LoginOrchestrationService");
var ReportingService_1 = require("../../api/ReportingService");
var LoginSimpleOrchestrationService_1 = require("../../services/LoginSimpleOrchestrationService");
var HalocAuthenticationService_1 = require("../../services/HalocAuthenticationService");
var LoadScript_1 = require("../../services/LoadScript");
var LoginConfiguration_1 = require("../../services/LoginConfiguration");
var LoginConsole = /** @class */ (function (_super) {
    __extends(LoginConsole, _super);
    function LoginConsole(props) {
        var _this = _super.call(this, props) || this;
        _this.halocFlag = true;
        _this.loginApi = new LoginApi_1.default();
        _this.halocAuthenticationService = new HalocAuthenticationService_1.default();
        _this.pageLoadEvent = false;
        _this.fullFlow = false;
        _this.postAuthError = false;
        _this.commonFunctions = null;
        _this.validateProps(props);
        _this.fullFlow = _this.props.data.fullFlow !== undefined ? _this.props.data.fullFlow : false;
        _this.updateForDeprecatedParameters();
        // Event handlers bindings
        _this.authenticatedSuccessfully = _this.authenticatedSuccessfully.bind(_this);
        _this.accountSelectionComplete = _this.accountSelectionComplete.bind(_this);
        _this.noWirelessAccountComplete = _this.noWirelessAccountComplete.bind(_this);
        _this.passcodeComplete = _this.passcodeComplete.bind(_this);
        _this.suppressIconHeading = _this.suppressIconHeading.bind(_this);
        _this.suppressSkipAuthentication = _this.suppressSkipAuthentication.bind(_this);
        _this.suppressSavedId = _this.suppressSavedId.bind(_this);
        _this.suppressCreateOneLink = _this.suppressCreateOneLink.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        // Setup intial state
        _this.state = new LoginConsoleState_1.default();
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        _this.postAuthError = _this.commonFunctions.getQueryParam('postAuthError') != null;
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.initializeEvents();
        _this.defaultsManagerService = new DefaultsManagerService_1.DefaultsManagerService(_this.props);
        _this.orchestrator = _this.createOrchestrator();
        _this.pageLoadEvent = (_this.props.options !== null &&
            _this.props.options !== undefined &&
            _this.props.options.pageLoadEvent !== null &&
            _this.props.options.pageLoadEvent !== undefined &&
            _this.props.options.pageLoadEvent)
            ? true : false;
        if (_this.props.options !== null &&
            _this.props.options !== undefined &&
            _this.commonFunctions.notBlankCheck(_this.props.options.flowCode)) {
            // this.stateManager.set('flowCode', this.props.options.flowCode);
            sessionStorage.setItem('flowCode', _this.props.options.flowCode);
        }
        console.log('LoginConsole channel : ', _this.props.data.channel);
        // For now if we're passed as registration OP, turn off HALO
        if (_this.props &&
            _this.props.options &&
            _this.props.options.registrationOriginationPoint &&
            _this.props.options.registrationOriginationPoint !== 'idplgn') {
            /**
             * // this.halocFlag = false;
             */
            sessionStorage.setItem('reg.forgot.op', _this.props.options.registrationOriginationPoint);
        }
        return _this;
    }
    LoginConsole.prototype.initializeEvents = function () {
        var _this = this;
        var CMSDataResponse = cms_integration_1.CMS.route(this, 'login', '/idpcms/services/prod/login.cmsfeed.js');
        CMSDataResponse.then(function () {
            _this.LoginConsoleCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
            _this.setState({ isCMSCallCompleted: true });
            // console.log('LoginConsole CmsData = ' + JSON.stringify(this.LoginConsoleCmsData));
        });
    };
    LoginConsole.prototype.componentDidMount = function () {
        this.setupLoginConsoleEventListeners();
        if (this.fullFlow && !this.postAuthError) {
            this.orchestrator.getNextState();
        }
        sessionStorage.removeItem(HalocAuthenticationService_1.IGNORE_EXPIRED_CAUTHNSTATE_FLAG);
    };
    LoginConsole.prototype.suppressIconHeading = function () {
        return this.defaultsManagerService.getBoolean('suppressHeader');
    };
    LoginConsole.prototype.suppressSkipAuthentication = function () {
        return this.defaultsManagerService.getBoolean('suppressSkipAuthLink');
    };
    LoginConsole.prototype.suppressSavedId = function () {
        return this.defaultsManagerService.getBoolean('suppressSavedId');
    };
    LoginConsole.prototype.suppressCreateOneLink = function () {
        return this.defaultsManagerService.getBoolean('suppressCreateOneLink');
    };
    LoginConsole.prototype.showUnauthenticatedPayments = function () {
        return this.defaultsManagerService.getBoolean('showUnauthenticatedPayments');
    };
    LoginConsole.prototype.registrationOriginationPoint = function () {
        return this.defaultsManagerService.getString('registrationOriginationPoint');
    };
    LoginConsole.prototype.suppressUserIdPopupLinks = function () {
        return this.defaultsManagerService.getBoolean('suppressUserIdPopupLinks');
    };
    LoginConsole.prototype.getClientId = function () {
        return this.commonFunctions.notBlankCheck(this.props.data.haloClientId) ?
            this.props.data.haloClientId : this.commonFunctions.getHalocAppIdForEnv();
    };
    LoginConsole.prototype.setCampaignForAnalyticsCookie = function () {
        var json = {};
        var setcookie = false;
        if (this.commonFunctions.getQueryParam('source')) {
            json.source = this.commonFunctions.getQueryParam('source');
            setcookie = true;
        }
        if (this.commonFunctions.getQueryParam('wtExtndSource')) {
            json.wtExtndSource = this.commonFunctions.getQueryParam('wtExtndSource');
            setcookie = true;
        }
        if (document.location.href.indexOf('/acctmgmt/login') === -1) {
            json.loginDestinationUrl = document.location.href;
            setcookie = true;
        }
        if (setcookie) {
            json.timestamp = (new Date()).toISOString();
            var value = encodeURIComponent(JSON.stringify(json));
            document.cookie = "Campaign_For_Analytics=" + value + "; domain=.att.com; path=/;";
            console.log("login-ui::LoginPage setting Campaign_For_Analytics=" + value);
        }
    };
    LoginConsole.prototype.renderLoginFlow = function () {
        if (this.fullFlow) {
            return (this.renderFullFlow());
        }
        else {
            return (this.renderMVPFlow());
        }
    };
    // Handles rendering of full integrated flow
    LoginConsole.prototype.renderFullFlow = function () {
        if (this.commonFunctions.notBlankCheck(this.commonFunctions.getQueryParam('postAuthError'))
            && this.commonFunctions.getQueryParam('postAuthError') === 'true') {
            // Ensure we clear this here.
            sessionStorage.removeItem('halo.hit.count');
            return this.renderGenericError();
        }
        var userDestinationPageValue = null;
        if (this.commonFunctions.notBlankCheck(this.state.userDestinationPage) &&
            this.state.userDestinationPage === GetUserCurrentStateResponse_1.UserDestinationPage.HALO_LOGIN) {
            console.log('UserDestinationPage.HALO_LOGIN');
            console.log('halocFlag ', this.halocFlag);
            if (!this.halocFlag) {
                console.log('redirecting to Login');
                userDestinationPageValue = GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN;
            }
            else {
                console.log('redirecting to HALO_LOGIN');
                userDestinationPageValue = GetUserCurrentStateResponse_1.UserDestinationPage.HALO_LOGIN;
            }
        }
        else {
            console.log('BAU userDestinationPage :  ', this.state.userDestinationPage);
            userDestinationPageValue = this.state.userDestinationPage;
        }
        switch (userDestinationPageValue) {
            case GetUserCurrentStateResponse_1.UserDestinationPage.ACCOUNT_SELECTION: {
                return this.renderAccountSelection();
            }
            case GetUserCurrentStateResponse_1.UserDestinationPage.NONE: {
                return this.renderNoWirelessAccount();
            }
            case GetUserCurrentStateResponse_1.UserDestinationPage.HALO_LOGIN: {
                var halocUrl = void 0;
                var clientId = this.getClientId();
                if (this.props &&
                    this.props.options &&
                    this.props.options.registrationOriginationPoint &&
                    this.props.options.registrationOriginationPoint !== 'idplgn') {
                    halocUrl = this.commonFunctions.doLoginUrl('false', this.getClientId(), this.getReturnUrl());
                }
                else {
                    halocUrl = this.commonFunctions.createHalocUrl('false', this.getClientId(), this.getReturnUrl());
                }
                // Non-services flow needs t his set here to prevent extra steps
                if (clientId !== LoginConfiguration_1.default.haloCServicesMechIdProd &&
                    clientId !== LoginConfiguration_1.default.haloCServicesMechIdTest) {
                    this.halocAuthenticationService.setHaloVisitedFlag('halocLoginRedirectionDone', this.getClientId());
                }
                this.setCampaignForAnalyticsCookie();
                window.location.href = halocUrl;
                return this.renderBusy();
            }
            case GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN: {
                return this.renderLoginWidget();
            }
            case GetUserCurrentStateResponse_1.UserDestinationPage.PASSCODE_VALIDATION: {
                return this.renderPasscode();
            }
            case GetUserCurrentStateResponse_1.UserDestinationPage.POSTAUTHERROR: {
                return this.renderGenericError();
            }
            default: {
                return this.renderBusy();
            }
        }
    };
    // Handlers the rendering of just the MVP page flow
    LoginConsole.prototype.renderMVPFlow = function () {
        if (this.halocFlag || (!this.halocFlag && this.props.data.halocEnabled)) {
            var halocUrl = this.commonFunctions.createHalocUrl('false');
            this.halocAuthenticationService.setHaloVisitedFlag('halocLoginRedirectionDone', this.getClientId());
            window.location.href = halocUrl;
            return;
        }
        else {
            return (React.createElement("div", null, this.renderLoginWidget()));
        }
    };
    LoginConsole.prototype.renderLoginWidget = function () {
        return (React.createElement(LoginWidget_1.default, { data: {
                loginUrl: this.getLoginUrl(),
                mvpView: !this.fullFlow,
                returnUrl: this.getReturnUrl(),
            }, options: {
                suppressHeader: this.suppressIconHeading(),
                suppressSkipAuthLink: this.suppressSkipAuthentication(),
                suppressSavedId: this.suppressSavedId(),
                suppressCreateOneLink: this.suppressCreateOneLink(),
                showUnauthenticatedPayments: this.showUnauthenticatedPayments(),
                registrationOriginationPoint: this.registrationOriginationPoint(),
                suppressUserIdPopupLinks: this.suppressUserIdPopupLinks(),
                pageLoadEvent: this.pageLoadEvent,
            } }));
    };
    LoginConsole.prototype.renderNoWirelessAccount = function () {
        return (React.createElement(NoWirelessAccount_1.default, { data: {
                loggedInAccount: this.state.loggedInUserId,
                filter: this.props.data.filter,
            } }));
    };
    LoginConsole.prototype.renderAccountSelection = function () {
        return (React.createElement(AccountSelection_1.default, { data: {
                accountList: this.state.accountList,
                loggedInAccount: this.state.loggedInUserId,
            }, options: {
                pageLoadEvent: this.pageLoadEvent,
            } }));
    };
    LoginConsole.prototype.renderPasscode = function () {
        var passcodeComponentDisplay = (React.createElement(PasscodeV2_1.default, { data: {
                // asmIndex: this.state.passcodeAccountList[0].asmIndex,
                accountList: this.state.passcodeAccountList,
                channel: this.props.data.channel,
                hasAccountSelection: this.state.hasAccountSelection,
                loginUrl: this.props.data.loginUrl,
                // maskedBAN: this.state.passcodeAccountList[0].maskedBan,
                returnUrl: this.getReturnUrl(),
            }, options: {
                pageLoadEvent: this.pageLoadEvent,
                skipInvalidateOnCancel: (this.props.options &&
                    this.props.options.skipInvalidateOnCancel ? true : false),
            } }));
        return (React.createElement("div", null, passcodeComponentDisplay));
    };
    LoginConsole.prototype.renderBusy = function () {
        return (React.createElement("div", { style: {
                marginLeft: '35%',
                marginRight: '35%',
                marginTop: '200px',
            } },
            React.createElement(CommonSpinner_1.default, null)));
    };
    LoginConsole.prototype.renderGenericError = function () {
        return (React.createElement(GenericError_1.default, { data: {} }));
    };
    LoginConsole.prototype.authenticatedSuccessfully = function (data) {
        var _this = this;
        console.log("authentictedSucessfully (fullFlow " + this.fullFlow + "), ", data);
        // If canceled we just notify backup
        if (this.fullFlow && data.authenticated) {
            console.log('Authenticated, fullFlow, getting next state');
            this.setState({
                authenticated: data.authenticated,
                cancelled: data.cancelled,
            }, function () {
                _this.orchestrator.getNextState();
            });
        }
        else {
            this.setState({
                authenticated: data.authenticated,
                cancelled: data.cancelled,
                errorMessage: data.errorMessage,
                errorId: data.errorId,
            }, function () {
                _this.triggerEndFlow();
            });
        }
    };
    LoginConsole.prototype.triggerEndFlow = function () {
        console.log('login-ui :: triggerEndFlow', this.state);
        if (this.state.authenticated) {
            this.halocAuthenticationService.setHaloVisitedFlag('halocLoginRedirectionDone', this.getClientId());
            // We have an authenticated trigger end flow, but don't have a valid
            // cauthnstate cookie.   This is likely a timesync issue.  setting flag
            // to ignore cauthnstage for myatt-app-shell
            if (this.halocAuthenticationService.getValidCAuthNState() === '') {
                sessionStorage.setItem(HalocAuthenticationService_1.IGNORE_EXPIRED_CAUTHNSTATE_FLAG, 'true');
            }
        }
        if (this.props.events && this.props.events.isAuthenticated) {
            this.props.events.isAuthenticated(this.state.authenticated, this.state.cancelled);
        }
        if (this.props.events && this.props.events.loginConsoleComplete) {
            var status_1 = {
                authenticated: this.state.authenticated,
                cancelled: this.state.cancelled,
                userId: this.state.loggedInUserId,
            };
            if (this.state.cancelled) {
                status_1.errorId = this.state.errorId;
                status_1.errorMessage = this.state.errorMessage;
            }
            this.props.events.loginConsoleComplete(status_1);
        }
    };
    LoginConsole.prototype.accountSelectionComplete = function (data) {
        var _this = this;
        console.log('accountSelectionComplete', JSON.stringify(data));
        var maskedBan = '';
        for (var _i = 0, _a = this.state.accountList; _i < _a.length; _i++) {
            var asm = _a[_i];
            if (asm.asmIndex === data.selectedValue) {
                maskedBan = asm.maskedBan;
                break;
            }
        }
        console.log('accountSelectionComplete - maskedBan', maskedBan);
        this.setState({
            asmIndex: data.selectedValue,
            selectedMaskedBan: maskedBan,
            userDestinationPage: null,
        }, function () {
            _this.orchestrator.getNextStateForSelectedAccount(data.selectedValue);
        });
    };
    LoginConsole.prototype.noWirelessAccountComplete = function (data) {
        var _this = this;
        console.log('noWirelessAccountComplete', data);
        if (data.status === NoWirelessAccount_2.NoWirelessAccountCompleteStatus.LOGIN_ANOTHER) {
            var gotoUrl = this.commonFunctions.getHaloCLogoutUrlForEnv()
                + encodeURIComponent(this.commonFunctions.createHalocUrl('false', this.getClientId(), this.getReturnUrl()));
            console.log('LoginConsole redirecting to HALO logout and login page ', gotoUrl);
            window.location.href = gotoUrl;
            return;
        }
        else {
            this.setState({
                authenticated: false,
                cancelled: true,
                userDestinationPage: null,
            }, function () {
                _this.triggerEndFlow();
            });
        }
    };
    LoginConsole.prototype.passcodeComplete = function (data) {
        var _this = this;
        console.log('passcodeComplete', data);
        if (data.status === PasscodeV2_1.PasscodeCompleteStatus.ACCOUNT_SELECTION) {
            console.log('PasscodeCompleteStatus.ACCOUNT_SELECTION');
            this.setState({ userDestinationPage: GetUserCurrentStateResponse_1.UserDestinationPage.ACCOUNT_SELECTION });
        }
        else {
            this.setState({
                authenticated: true,
                cancelled: false,
                userDestinationPage: null,
            }, function () {
                // this.triggerEndFlow();
                if (_this.state.selectedMaskedBan) {
                    _this.orchestrator.getNextStateForSelectedAccount(_this.state.selectedMaskedBan);
                }
                else {
                    _this.orchestrator.getNextState();
                }
            });
        }
    };
    LoginConsole.prototype.setupLoginConsoleEventListeners = function () {
        var loginSuccess = {
            eventHandler: this.authenticatedSuccessfully,
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: 'loginSuccessEvent',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(loginSuccess);
        var noWirelessAccountListener = {
            eventHandler: this.noWirelessAccountComplete,
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: NoWirelessAccount_1.default.noWirelessAccountCompleteEvent,
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(noWirelessAccountListener);
        var accountSelectionCompleteListener = {
            eventHandler: this.accountSelectionComplete,
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: AccountSelection_1.default.accountSelectionContinueEventName,
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(accountSelectionCompleteListener);
        var passcodeCompleteListener = {
            eventHandler: this.passcodeComplete,
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: PasscodeV2_1.default.passcodeSuccessEventName,
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(passcodeCompleteListener);
    };
    LoginConsole.prototype.getReturnUrl = function () {
        if (this.props.data && this.props.data.returnUrl) {
            return this.props.data.returnUrl;
        }
        else if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            var url = document.location.href;
            /*  +
            ( document.location.href.indexOf( '?' ) === -1 ? '?' : '&' ) +
                'authenticated=true';
            */
            // return 'https://www.att.com/shop/unified/authentication.html';
        }
    };
    LoginConsole.prototype.getLoginUrl = function () {
        if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            return document.location.href;
        }
    };
    LoginConsole.prototype.componentWillUnmount = function () {
        event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(event_bus_1.ICCEventBusManager.getUUID());
    };
    LoginConsole.prototype.validateProps = function (props) {
        // If intent is used, send a warning.
        if (props.data.intent != null) {
            console.warn("LoginConsole data.intent property is DEPRECATED!  Please switch to " +
                ("channel,flowType,filter paramaters.  intent: " + props.data.intent));
            // If intent not set need channel and flow type
        }
        else {
            if (!props.data.channel) {
                throw new Error('channel not provided');
            }
            if (!props.data.flowType) {
                throw new Error('flowType not provided');
            }
            if (props.data.fullFlow !== undefined) {
                throw new Error('fullFlow parameter not longer has meaning with channel and flowType parameters');
            }
        }
        if (props.events && props.events.loginConsoleComplete && props.events.isAuthenticated) {
            // tslint:disable-next-line:max-line-length
            throw new Error('LoginConsole events for both loginConsoleComplete and isAuthenticated provided, please just use loginConsoleComplete');
        }
    };
    LoginConsole.prototype.updateForDeprecatedParameters = function () {
        if (this.props.data.intent !== null && this.props.data.intent !== undefined) {
            if (this.props.data.intent === 'sales-wireless') {
                this.props.data.channel = 'sales';
                this.props.data.flowType = LoginConsoleProps_1.FlowType.ACCOUNT_IN_FOCUS;
                this.props.data.filter = 'wireless';
            }
            else if (this.props.data.intent === 'services') {
                this.props.data.channel = 'services';
                this.props.data.flowType = LoginConsoleProps_1.FlowType.SERVICES;
            }
        }
        else if (this.props.data.channel) {
            this.fullFlow = true;
        }
    };
    LoginConsole.prototype.createOrchestrator = function () {
        switch (this.props.data.flowType) {
            case LoginConsoleProps_1.FlowType.ACCOUNT_IN_FOCUS:
            case LoginConsoleProps_1.FlowType.SERVICES:
            case LoginConsoleProps_1.FlowType.NOAUTH_ACCOUNT_IN_FOCUS:
            case LoginConsoleProps_1.FlowType.NOAUTH_SERVICES:
                return new LoginOrchestrationService_1.LoginOrchestrationService(this, this.props);
            case LoginConsoleProps_1.FlowType.LOGIN_SIMPLE:
                return new LoginSimpleOrchestrationService_1.LoginSimpleOrchestrationService(this, this.props);
        }
    };
    LoginConsole.prototype.checkSendHALOFormResponse = function (response) {
        var page = response.content.destinationPage;
        // If not halo or if we get a LOGIN response don't need to do anything
        if (page === GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN || page === GetUserCurrentStateResponse_1.UserDestinationPage.HALO_LOGIN) {
            console.log("checkSendHALOFormResponse - LOGIN response " + page);
            return;
        }
        var halocAuthenticationService = new HalocAuthenticationService_1.default();
        if (typeof HALOReportingBridge === 'undefined') {
            var server = (document.location.hostname === 'localhost'
                || document.location.hostname.indexOf('.stage.') > -1) ?
                'https://myattqa1.stage.att.com' :
                '';
            LoadScript_1.LoadScript.loadScript(server + "/ui/services_co_myatt_login/1.0.0/halo-application-edm-bridge.js", 'halo-edm-bridge-js')
                .then(function () {
                try {
                    HALOReportingBridge.checkForHaloLoginEventNeeded(response.content.reportingAccounts);
                }
                catch (excp) {
                    console.error("Exception firing HALO EDM Bridge event", excp);
                }
            });
        }
        else {
            try {
                HALOReportingBridge.checkForHaloLoginEventNeeded({});
            }
            catch (excp) {
                console.error("Exception firing HALO EDM Bridge event", excp);
            }
        }
    };
    LoginConsole.prototype.render = function () {
        if (!this.state.isCMSCallCompleted) {
            return (React.createElement("div", null,
                React.createElement(CommonSpinner_1.default, null)));
        }
        else {
            return (React.createElement("div", { className: [appStyles.loginWrapper].join(' ') },
                React.createElement(GridContainer_1.default, { options: { className: appStyles.loginContainer } },
                    React.createElement(GridRow_1.default, null,
                        React.createElement(GridColumn_1.default, { options: {
                                size: 12,
                                className: utilityStyles.padNone,
                                customOptions: '',
                            } }, this.renderLoginFlow())))));
        }
    };
    LoginConsole.passcodeSuccessEventName = 'passcodeSuccessEvent';
    return LoginConsole;
}(React.Component));
exports.default = LoginConsole;
//# sourceMappingURL=LoginConsole.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LoginConsole/LoginConsole.js
// module id = 1481
// module chunks = 8